import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { MeteringPoint, MeteringPointFunctionControlContract } from '@model';
import { Store } from '@ngrx/store';
import * as mpStore from '@appStore/metering-points';
import { filter, Observable } from 'rxjs';
import { SubSink } from 'subsink';

@Component({
    selector: 'app-function-control-contract',
    templateUrl: './function-control-contract.component.html',
    standalone: false
})
export class FunctionControlContractComponent implements OnInit, OnChanges {
  @Input()
  meteringPoint: MeteringPoint;
  @Input()
  containedMeteringPoint: MeteringPoint;

  meteringPointsWithFunctionsControlContract$: Observable<MeteringPoint[]>;
  functionControlContract: MeteringPointFunctionControlContract;
  private subs = new SubSink();

  containedMeteringPointsWithFunctionsControlContract$: Observable<MeteringPoint[]>;

  constructor(
    private meteringStore: Store<mpStore.State>
  ) { }

  ngOnInit(): void {


    // Same metering point
    if(this.meteringPoint.hasFunctionControl && !this.containedMeteringPoint) {

      if (!this.meteringPoint.functionControlContract) {
        this.meteringStore.dispatch(new mpStore.LoadMeteringPointFunctionControlContract({
          masterMeteringPointId: this.meteringPoint.id,
          meteringPointId: this.meteringPoint.id
        }));
      }

      this.meteringPointsWithFunctionsControlContract$ = this.meteringStore.select(mpStore.getMeteringPointFunctionControlContract);
      this.subs.sink = this.meteringPointsWithFunctionsControlContract$.pipe(filter(x => !!x)).subscribe(mps => {

        let filteredMp = mps.find(mp => mp.id === this.meteringPoint.id);
        this.functionControlContract = filteredMp ? filteredMp.functionControlContract : null;
      });

    } else if(this.containedMeteringPoint && this.containedMeteringPoint.hasFunctionControl) {
      // Contained metering point

      if (!this.containedMeteringPoint.functionControlContract) {
        this.meteringStore.dispatch(new mpStore.LoadMeteringPointFunctionControlContract(
          {
            masterMeteringPointId: this.meteringPoint.id,
            meteringPointId: this.containedMeteringPoint.id
          }
        ));
      }
      this.containedMeteringPointsWithFunctionsControlContract$ = this.meteringStore.select(mpStore.getMeteringPointFunctionControlContract);
      this.subs.sink = this.containedMeteringPointsWithFunctionsControlContract$.pipe(filter(x => !!x)).subscribe(mps => {

         // Master meteringPoint
        let filteredMp = mps.find(mp => mp.id === this.meteringPoint.id);
        let filteredContainedMp = filteredMp.containedMeteringPoints.find(mp => mp.id === this.containedMeteringPoint.id);
        this.functionControlContract = filteredContainedMp ? filteredContainedMp.functionControlContract : null;
      });

    }
  }

  ngOnChanges() {

    if (this.containedMeteringPoint && this.containedMeteringPoint.hasFunctionControl && this.containedMeteringPoint.functionControlContractLoaded) {
     
      this.functionControlContract = this.containedMeteringPoint ? this.containedMeteringPoint.functionControlContract : null;
    }
  }
}
